/**
 * Traductions des noms de paramètres en arabe
 * Utilisé pour afficher les noms techniques en arabe dans l'interface
 * Dernière modification : ajout de allowTeacherToAddAxamPoints
 */
export const parametersAr: { [key: string]: string } = {
  // Paramètres de suivi du Coran
  'targetRepeatNewHifzCount': 'تكرار الحفظ الجديد',
  'repeatOldHifzCount': 'تكرار الحفظ القديم',
  'repeatReviewCount': 'تكرار المراجعة',
  'dailyGoal': 'الهدف اليومي',
  'weeklyGoal': 'الهدف الأسبوعي',
  'monthlyGoal': 'الهدف الشهري',
  
  // Paramètres de permissions
  'allowTeacherToAddExamPoints': 'السماح للمعلم بإضافة نقاط الامتحان',
  
  // Paramètres de validation
  'checkEmailUniquenessForUsers': 'التحقق من عدم تكرار البريد الإلكتروني للمستخدمين',
  
  // Paramètres généraux
  'applicationName': 'اسم التطبيق',
  'organizationName': 'اسم المؤسسة',
  'contactEmail': 'البريد الإلكتروني للتواصل',
  'contactPhone': 'رقم الهاتف للتواصل',
  'address': 'العنوان',
  
  // Paramètres académiques
  'academicYearStart': 'بداية السنة الدراسية',
  'academicYearEnd': 'نهاية السنة الدراسية',
  'maxStudentsPerClass': 'الحد الأقصى للطلاب في الحلقة',
  'minAttendancePercentage': 'نسبة الحضور الدنيا',
  
  // Paramètres financiers
  'monthlyFee': 'الرسوم الشهرية',
  'annualRegistrationFee': 'رسوم التسجيل السنوية',
  'lateFeePercentage': 'نسبة رسوم التأخير',
  
  // Paramètres de notification
  'enableEmailNotifications': 'تفعيل إشعارات البريد الإلكتروني',
  'enableSmsNotifications': 'تفعيل إشعارات الرسائل النصية',
  'notificationLanguage': 'لغة الإشعارات',
  
  // المنطقة الزمنية
  'default_timezone': 'المنطقة الزمنية للجمعية',

  // Paramètres système
  'maintenanceMode': 'وضع الصيانة',
  'apiTimeout': 'مهلة الاتصال بالخادم',
  'maxFileUploadSize': 'الحد الأقصى لحجم الملف',
  'allowedFileTypes': 'أنواع الملفات المسموحة',
  
  // Si le paramètre n'est pas trouvé, on retourne le nom original
};

/**
 * Fonction pour obtenir la traduction d'un nom de paramètre
 * @param parameterName - Le nom technique du paramètre
 * @returns La traduction en arabe ou le nom original si non trouvé
 */
export const getParameterNameAr = (parameterName: string): string => {
  return parametersAr[parameterName] || parameterName;
};
